import { convertTimeTo12Hr } from 'utils/bolt/showtimes';
import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';

export const getScreeningDetailsFormatted = ({ date, time, format }, clockFormat) => {
	const dateParts = date.split('-');
	let screeningDate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
	const copy = Store.get()?.appData?.copy?.baseCopy?.$DATETIME_LOCALE || {};
	screeningDate = formatDateTime(screeningDate, 'ddd dd MMM', copy);
	if ((clockFormat || '24') === '12') {
		time = convertTimeTo12Hr(time);
	}

	return {
		date: screeningDate,
		time,
		format: format || '2D'
	};
};